/**
 * 获取登录信息
 */
import common from './common'
const getUserInfo = () => {
    /**
     * 1.默认取缓存数据
     * 2. 如果换成没有  就取安卓方法的数据
     */
    let userInfo: any = !!window.localStorage.getItem('userInfo') ? JSON.parse(window.localStorage.getItem('userInfo')) : null
    if (!userInfo) {
        if (!common?.isAndroid_ios()) {
            if (window?.androidNative?.getUserInfo) {
                const _userInfo = window.androidNative.getUserInfo()
                window.localStorage.setItem('userInfo', _userInfo)
                userInfo = JSON.parse(_userInfo)
            }
        } else {
            //IOS
            userInfo = JSON.parse(window.localStorage.getItem('userInfo')) || {}
        }
    }

    return userInfo
}

export default getUserInfo